<!-- 견적서 작성 -->
<template>
  <div>
    <!-- 관리자 등록 -->
    <div class="lp-modal-wrapper" v-if="value.type==='create'">
      <div class="title">관리자 등록</div>
      <div class="columns is-multiline">
        <div class="column is-full">
          <admin-form-item>
            <div class="lp-valid-error">{{ errMsg }}</div>
          </admin-form-item>
        </div>
        <div class="column is-full">
          <admin-form-item label="아이디">
            <input class="input"
                   style="width:250px"
                   :value="value.username"
                   @input="e => value.username = e.target.value"
                   type="text"
                   maxlength="20">
          </admin-form-item>
        </div>
        <div class="column is-full">
          <admin-form-item label="비밀번호">
            <input class="input"
                   style="width:250px"
                   :value="value.password"
                   @input="e => value.password = e.target.value"
                   type="password"
                   maxlength="20">
          </admin-form-item>
        </div>
        <div class="column is-full">
          <admin-form-item label="비밀번호 확인">
            <input class="input"
                   style="width:250px"
                   :value="value.passwordCheck"
                   @input="e => value.passwordCheck = e.target.value"
                   type="password"
                   maxlength="20">
          </admin-form-item>
        </div>
        <div class="column is-full">
          <admin-form-item label="이름">
            <input class="input"
                   style="width:250px"
                   :value="value.name"
                   @input="e => value.name = e.target.value"
                   type="text"
                   maxlength="20">
          </admin-form-item>
        </div>
        <div class="column is-full">
          <admin-form-item label="이메일">
            <input class="input"
                   style="width:250px"
                   :value="value.email"
                   @input="e => value.email = e.target.value"
                   type="text"
                   maxlength="50">
          </admin-form-item>
        </div>
        <div class="column is-full">
          <admin-form-item label="휴대전화번호">
            <input class="input"
                   style="width:250px"
                   :value="value.phone"
                   @input="e => value.phone = e.target.value"
                   type="text"
                   maxlength="50">
          </admin-form-item>
        </div>
      </div>
      <div class="btn-group-justify-end">
        <button class="button is-light" @click="cancelModal">취소</button>
        <button @click="regAdmin" class="button is-primary">등록하기</button>
      </div>
    </div>

    <!-- 관리자 수정 -->
    <div class="lp-modal-wrapper" v-if="value.type==='modify'">
      <admin-box-item title="관리자 수정" :useTab="false">
        <div class="columns is-multiline">
          <div class="column is-full">
            <admin-form-item>
              <div class="lp-valid-error">{{ errMsg }}</div>
            </admin-form-item>
            <admin-form-item label="아이디">
              <input class="input"
                     style="width:250px"
                     :value="value.username"
                     @input="e => value.username = e.target.value"
                     type="text"
                     maxlength="20"
                     :disabled="true">
            </admin-form-item>
          </div>

          <div class="column is-full">
            <admin-form-item label="이름">
              <input class="input"
                     style="width:250px"
                     :value="value.name"
                     @input="e => value.name = e.target.value"
                     type="text"
                     maxlength="20">
            </admin-form-item>
          </div>

          <div class="column is-full">
            <admin-form-item label="이메일">
              <input class="input"
                     style="width:250px"
                     :value="value.email"
                     @input="e => value.email = e.target.value"
                     type="text"
                     maxlength="50">
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="휴대전화번호">
              <input class="input"
                     style="width:250px"
                     :value="value.phone"
                     @input="e => value.phone = e.target.value"
                     type="text"
                     placeholder="010-1234-5678"
                     maxlength="13">
            </admin-form-item>
          </div>
        </div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="cancelModal">취소</button>
          <button @click="modifyAdmin" class="button is-primary">수정하기</button>
        </div>
      </admin-box-item>
    </div>

    <!-- 관리자 패스워드 변경 -->
    <div class="lp-modal-wrapper" v-if="value.type==='password'">
      <admin-box-item :title="value.username +'의 비밀번호 변경'" :useTab="false">
        <div class="columns is-multiline">
          <div class="column is-full">
            <admin-form-item>
              <div class="lp-valid-error">{{ errMsg }}</div>
            </admin-form-item>
          </div>


          <div class="column is-full">
            <admin-form-item label="현재 비밀번호">
              <input class="input"
                     style="width:250px"
                     :value="value.origin_password"
                     @input="e => value.origin_password = e.target.value"
                     type="password"
                     maxlength="20">
            </admin-form-item>
          </div>

          <div class="column is-full">
            <admin-form-item label="새 비밀번호">
              <input class="input"
                     style="width:250px"
                     :value="value.password"
                     @input="e => value.password = e.target.value"
                     type="password"
                     maxlength="20">
            </admin-form-item>
          </div>

          <div class="column is-full">
            <admin-form-item label="새 비밀번호 확인">
              <input class="input"
                     style="width:250px"
                     :value="value.passwordCheck"
                     @input="e => value.passwordCheck = e.target.value"
                     type="password"
                     maxlength="20">
            </admin-form-item>
          </div>
        </div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="cancelModal">취소</button>
          <button @click="changePassword" class="button is-primary">확인</button>
        </div>
      </admin-box-item>
    </div>
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";

  export default {
    props: ['data'],
    components: {
      AdminFormItem
    },
    data() {
      return {
        value: {
          id:'',
          password:'',
          passwordCheck:'',
          origin_password: '',
          username:'',
          name:'',
          email:'',
          phone:'',
        },
        errMsg:''
      }
    },
    created() {
      this.value = this.data;

    },
    watch: {
      data(n) {
        if (n) {
          this.value = n;
          this.errMsg = '';
        }
      },
      'value.phone'(n) {
        if(n) this.value.phone = autoHyphenPhone(this.value.phone)
      },
    },
    methods: {
      cancelModal(){
        this.$store.commit('cancelModal');
      },
      // 관리자 등록
      regAdmin(){
        if(!this.value.username){
          this.errMsg = '이메일을 입력해주세요.';
          return
        }
        else if(!this.value.password) {
          this.errMsg = '비밀번호를 입력해주세요.';
          return;
        }
        else if(this.value.password !== this.value.passwordCheck) {
          this.errMsg = '비밀번호를 확인해주세요.';
          return;
        }

        this.$axios.post('admin/member/admin', this.value).then(res=>{
          if(res.status===200){
            //this.$refs.regAdminModal.close();
            this.value = {
              id:'',
              name:'',
              email:'',
              password:'',
              passwordCheck:'',
              origin_password: '',
              username:'',
              phone:'',
              type: this.value.type
            };
            this.errMsg = '';
            this.$store.commit('closeModal');
          }
        }).catch(error=>{
          if(error.response) {
            if(error.response.data.message==='exists') {
              this.toast('이미 가입된 아이디가 있습니다.')
            } else {
              this.toast(error.response.data.message);
            }
          }
        })
      },
      // 관리자 수정
      modifyAdmin(){
        if(!this.value.username){
          this.errMsg = '이메일을 입력해주세요.';
          return
        }
        let url = 'admin/member/admin/'+this.value.id
        if(this.data.id===this.$store.getters.admin.id) {
          url += '/mine'
        }
        let params = {
          username: this.value.username,
          name: this.value.name,
          email: this.value.email,
          phone: this.value.phone
        };
        this.$axios.patch(url, params).then(res=>{
          if(res.status===200){
            this.toast('저장되었습니다.');
            this.value = {
              id:'',
              name:'',
              email:'',
              password:'',
              passwordCheck:'',
              origin_password: '',
              username:'',
              phone:'',
              type: this.value.type
            };
            this.errMsg = '';
            this.$store.commit('closeModal');
          }
        })
      },
      // 비밀번호 변경
      changePassword(){
        if(!this.value.username){
          this.errMsg = '이메일을 입력해주세요.';
          return
        }
        else if(!this.value.password) {
          this.errMsg = '비밀번호를 입력해주세요.';
          return;
        }
        else if(this.value.password !== this.value.passwordCheck) {
          this.errMsg = '비밀번호를 확인해주세요.';
          return;
        }
        else if(!this.value.origin_password) {
          this.errMsg = '현재비밀번호를 입력해주세요.';
          return;
        }

        this.$axios.post('auth/admin/login', {
          username: this.value.username,
          password: this.value.origin_password
        }).then(res => {
          if(res.status===200) {
            if(this.data.id===this.$store.getters.admin.id) {
              this.$axios.patch('admin/member/admin/'+this.value.id+'/password/mine', {
                password: this.value.password
              }).then(res=>{
                if(res.status===200){
                  this.errMsg = '';
                  this.toast('변경되었습니다.');
                  this.$store.commit('closeModal');
                }
              })
            } else {
              this.$axios.post('admin/member/admin/'+this.value.id+'/password', {
                password: this.value.password
              }).then(res=>{
                if(res.status===200){
                  this.errMsg = '';
                  this.toast('변경되었습니다.');
                  this.$store.commit('closeModal');
                }
              })
            }
          }
        }).catch(error => {
          if(!error.response && error.message) {
            this.errMsg = error.message;
          }
          else if (error.response.status > 400) {
            if (error.response.data.detail){
              this.errMsg = error.response.data.detail;
            }
            else{
              this.errMsg = error.response.data.message;
            }
          }
        });
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>

</style>
